import { useAppSelector } from '@store/hooks'
import { selectSelectedEventParticipation } from '@store/membership/EventParticipationReducer'
import { SBRMFormActionProps } from '@supplement-bacon/sbrm-react'
import { requiredRule } from '@utils/rules'
import { Form, Input, Result } from 'antd'
import { useEffect } from 'react'

const Delete = ({ form, formProps }: SBRMFormActionProps) => {
  const item = useAppSelector(selectSelectedEventParticipation())

  useEffect(() => {
    form.setFieldsValue(item)
  }, [item])

  return item ? (
    <Form {...formProps} form={form} layout="vertical">
      <Result
        title={'Are you sure ?'}
        subTitle={
          'In case of member participation deletion, all the guests linked to this member will also be deleted. This action is immediate and cannot be undone.'
        }
      />
      <Form.Item name="id" required rules={[requiredRule()]} className="d-none">
        <Input type="hidden" />
      </Form.Item>
    </Form>
  ) : (
    <></>
  )
}

export default Delete
